'use strict';

var cov_1524uaghn7 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.recurrent.factory.js',
        hash = '3864c50890eb461a2faa096f8fbc555b8f3cc1df',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.recurrent.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 29,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1524uaghn7.s[0]++;
(function () {
    'use strict';

    cov_1524uaghn7.f[0]++;
    cov_1524uaghn7.s[1]++;
    angular.module('app').factory('RecurrentTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1524uaghn7.f[1]++;
        cov_1524uaghn7.s[2]++;


        return restmod.model('/task-recurrences').mix('MixinContainable', {
            $config: {
                contains: {
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    }

                }
            }
        });
    }
})();